// extracted by mini-css-extract-plugin
module.exports = {"notice":"ReadonlyNotice_notice__AZhEI"};